import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux' 
import SpinnerSmall from '../SpinnerSmall';
import { TopHeaderSettings, CenterSettingsContainer } from './settings.styled';
import { SettingsInputContainer, SettingsSubmitButton, SettingsBody } from './settings.styled';
import { updateFullName } from 'features/settings/settingSlice';
import { toast } from 'react-toastify';
import { updateUser } from 'features/auth/authSlice';
import { useTranslation } from 'react-i18next';

function UpdateDisplayName(props) {
  const { t } = useTranslation('settings')

  const dispatch = useDispatch() 
  const [fullName, setFullName] = useState('')
  const { user } = useSelector((state) => state.auth)
  const { isUpdateFullNameLoading, isUpdateFullNameSuccess, newFullName } = useSelector((state) => state.settings)

  useEffect(() => {

    setFullName(user.fullName)

  }, [])


  useEffect(() => {
      if(isUpdateFullNameSuccess && newFullName){
        toast.success(t('accountEdit.displayNameUpdated'))
        setFullName(newFullName)
        dispatch(updateUser({
          type: 'fullName',
          value: newFullName
        }))
      }
  
  }, [isUpdateFullNameSuccess, newFullName, dispatch, t])


  const handleSubmit = () => {

    if(!fullName){
      return toast.error(t('accountEdit.nameRequired'))
    }

    if(fullName === user.fullName){
      return toast.error(t('accountEdit.noChanges'))
    }

    if(fullName.length < 3){
      return toast.error(t('accountEdit.nameMinimum'))
    }

    dispatch(updateFullName({
      fullName: fullName
    }))

  }

  return (
    <CenterSettingsContainer >
      <TopHeaderSettings>{t('accountEdit.updateDisplayName')}</TopHeaderSettings>
      
      <SettingsBody>
        <SettingsInputContainer> 
          <input 
            value={fullName} 
            onChange={(e) => setFullName(e.target.value)}
            name='email' 
            placeholder={ fullName } 
            disabled={isUpdateFullNameLoading}
          />
          <SettingsSubmitButton
            disabled={isUpdateFullNameLoading}
            onClick={handleSubmit}
            >
            {
              isUpdateFullNameLoading ? <SpinnerSmall /> : t('accountEdit.update')
            }
          </SettingsSubmitButton>
        </SettingsInputContainer>

      </SettingsBody>

    </CenterSettingsContainer>
  )
}

export default UpdateDisplayName
